import Basictabs from "components/common/Tabs";
import PropertyPlans from "./PropertyPlans";
import TemplatePlans from "./TemplatePlans";

function AbovePropertyList() {
  return (
    <>
      <Basictabs
        isParentTab
        tabDetails={[
          {
            label: "Property Plans",
            content: PropertyPlans
          },
          {
            label: "Template Plans",
            content: TemplatePlans
          }
        ]}
        alignItems="left"
        marginBottom="0"
      />
    </>
  );
}

export default AbovePropertyList;
